"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parensUnitConversion = void 0;
const getUnitConversion_1 = require("./getUnitConversion");
exports.parensUnitConversion = (igs, takeSecond) => igs.map(x => {
    if ("unit" in x && x.name && x.amount && x.unit) {
        const { second, first } = getUnitConversion_1.getUnitConversion(x);
        if (second && first) {
            return takeSecond ? second : first;
        }
    }
    return x;
});
//# sourceMappingURL=parensUnitConversion.js.map